import { IPermissionAction } from "@/features/auth/models/auth.types";

export const factoryPermission = (actionName: string): IPermissionAction => {
  return actionName;
};

export const Permission = {
  MACROGENERADORES_CONSULTA: factoryPermission("MG.FullAccess"),
  MACROGENERADORES_DASHBOARD: factoryPermission("MG.DV-POWERBI"),
} as const;

export type Permission = (typeof Permission)[keyof typeof Permission];

export type { IPermissionAction };
